import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface SocialLoginOverlayProps {
  isVisible: boolean;
  className?: string;
}

export function SocialLoginOverlay({
  isVisible,
  className,
}: SocialLoginOverlayProps) {
  const { t } = useTranslation('common');
  if (!isVisible) return null;

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm',
        className,
      )}
    >
      <div className='flex flex-col items-center space-y-4 rounded-lg bg-card p-8 shadow-lg'>
        <Loader2 className='h-8 w-8 animate-spin text-primary' />
        <div className='text-center'>
          <h3 className='text-lg font-semibold'>
            {t('labels.completingSocialLogin')}
          </h3>
          <p className='text-sm text-muted-foreground'>
            {t('labels.settingUpAccount')}
          </p>
        </div>
      </div>
    </div>
  );
}
